import type {
  MarketingLookupReqPayload,
  OrganizationMarketingResponse,
} from '../../types/offerings';
import { getApiConfig } from '../../services/api/utils';
import { OrganizationServiceApiClient } from '@highereducation/organizations';

/**
 * Fetches organization marketing data from the Organization Service SDK.
 */
export const fetchOrganizationMarketing = async (
  payload: MarketingLookupReqPayload,
  userAgent?: string,
): Promise<OrganizationMarketingResponse> => {
  const config = getApiConfig();
  const baseUrl = config.organizationApiUrl ?? '';

  const client = new OrganizationServiceApiClient({
    baseUrl,
    defaultHeaders: {
      'content-type': 'application/json',
    },
  });

  const response = await client.postMarketingLookup(
    payload,
    userAgent || 'unknown',
  );

  if (!response) {
    throw new Error('Failed to fetch organization marketing data');
  }

  return response as OrganizationMarketingResponse;
};
